// View Handler - handles forward, previous, progress spinner, blocking in onepage checkout

bq.viewHandler = function(element, options) {
  this.options   = options;
  this.$element  = $(element); //this will be the container element for the html
  this.waiting = false;
  this.blocked = false;
  this.$loadingMask = $('<div data-view-handler-loading class="view-handler-loading"><div class="view-handler-loading-inner"><span class="view-handler-icon-wrap"><span class="loader"></span></span><div data-view-handler-message class="view-handler-message">' + bq.messages.global.loadingGeneral + '</div></div></div>');
};

bq.viewHandler.DEFAULTS = {};

bq.viewHandler.prototype = {

  init: function() {
    var self = this;

    bq.debug.log("viewHandler : init()");

    this.$element.on('bq.viewhandler.block', function() {
      self.blocked = true;
    });

    this.$element.on('bq.viewhandler.unblock', function() {
      self.blocked = false;
    });

    this.$element.on('bq.viewhandler.start', function() {
      if(!self.blocked) {
        self._startViewTransition();
        self.$loadingMask.find('[data-view-handler-message]').text(bq.messages.global.loadingGeneral);
      } else {
        bq.debug.log("View is blocked, cannot proceed.")
      }
    });

    this.$element.on('bq.viewhandler.progressmessage', function(e, data) {
      if(!self.waiting) {
        self._startViewTransition();
      }

      if(data.message) {
	      if(self._stringContainsHtml(data.message)) {
		      self.$loadingMask.find('[data-view-handler-message]').html(data.message);
	      } else {
		      self.$loadingMask.find('[data-view-handler-message]').text(data.message);
	      }
      } else {
        self.$loadingMask.find('[data-view-handler-message]').text(bq.messages.global.loadingGeneral);
      }

      self._clickProcess();
    });

    this.$element.on('bq.viewhandler.keepspinner', function(){
      self.blocked = true;
    });
    
    this.$element.on('bq.viewhandler.stop', function() {
      if(!self.blocked) {
        self._stopViewTransition();
      } else {
        bq.debug.log("View is blocked, cannot proceed.");
      }
    });

    this.$element.on('bq.viewhandler.switch', function(e, data) {
      if(!self.blocked) {
        self._switchView(data.html);
      } else {
        bq.debug.log("View is blocked, cannot proceed.");
      }
    });

    if(this.$element.attr('data-view-handler') == 'link') {
      this.$element.on('click', function(){
        bq.helper.throwEvent('bq.viewhandler.start', self.$element);
      });
    }
  },

  _startViewTransition: function(){
    var $el = this.$element;
    this.waiting = true;

    if ($el[0].nodeName === "BUTTON") {
      $el = $('body');
    }
    $el.prepend(this.$loadingMask);
  },

  _stopViewTransition: function(){
    this.waiting = false;
    this.$loadingMask.remove();
  },

  _switchView: function(newHtml){
    var self = this,
        _newHtml = '';

    if(newHtml instanceof $) {
      _newHtml = newHtml.html();
    } else {
      _newHtml = newHtml;
    }

    this.$element.addClass('animated fadeOut');
    this.$element.one('oanimationend oAnimationEnd msAnimationEnd animationend',
      function(e) {
        $(this).html(_newHtml).removeClass('fadeOut').addClass('fadeIn');
        self._stopViewTransition();
      });
  },

  _clickProcess: function() {
    var element = this.$element;
    setTimeout(function () {
      if (element.attr('href')) {
        window.location = element.attr('href');
        return false;
      }
    }, 1);
  },

  _stringContainsHtml: function(string) {
    var result = false;
	  if (string.match(/<(\w+)((?:\s+\w+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/)) {
		  result = true;
	  }

	  return result;
  }

};

// viewHandler PLUGIN DEFINITION
// =======================

var viewHandlerold = $.fn.viewHandler;

$.fn.viewHandler = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.viewHandler');
    var options = $.extend({}, bq.viewHandler.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.viewHandler', (data = new bq.viewHandler(this, options))); }
    data.init();
  });
};

$.fn.viewHandler.Constructor = bq.viewHandler;

// viewHandler NO CONFLICT
// =================

$.fn.viewHandler.noConflict = function () {
  $.fn.viewHandler = viewHandlerold;
  return this;
};

// viewHandler DATA-API
// ==============

bq.viewHandlerInit = function() {
  function addToEl(){
    var el = $(this);
    if(el.data('bq.viewHandler')) { return; }
    el.viewHandler(el.data());
  }

  if($('[data-view-handler], .trigger-view-handler-on-click').length) {
    $('[data-view-handler], .trigger-view-handler-on-click').each(addToEl);

    if ($('[data-bq="grid"]').length) {
      $('body').each(addToEl);
    }

    if($('.trigger-view-handler-on-click').length) {
      $('.trigger-view-handler-on-click').on('click', function(e) {
        var $this = $(this);
        if($this.attr('type') === 'submit' && $this.parents('form').length && !($this.parents('form').parsley().isValid())) {
          return;
        }
        if($('.form-validation-error, .has-error, [data-bq="quick-order"] .has-warning').length) {
          return;
        }
        bq.helper.throwEvent('bq.viewhandler.progressmessage', $this, {message: bq.messages.global.loadingLongWait});
        if($this.attr('href')) {
          e.preventDefault();
          return false;
        }
      });
    }
  } else {
    $('body').each(addToEl);
  }
};

bq.init.push(bq.viewHandlerInit);